import IconWrapper, { IconWrapperProps } from '../IconWrapper';

type HomeProps = Pick<IconWrapperProps, 'className'>;

const Home = (props: HomeProps) => (
  <IconWrapper {...props} width={24} height={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.80042 12.0125L12.0129 4.80005L19.2254 12.0125L18.3769 12.8611L12.0129 6.49711L5.64894 12.8611L4.80042 12.0125ZM7.8129 13.8126H6.6129L6.6129 18.0126L6.6129 19.2126H7.8129H16.2129L17.4129 19.2126V18.0126V13.8126H16.2129V18.0126H7.8129V13.8126Z"
      fill="currentColor"
    />
  </IconWrapper>
);

export default Home;

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.80042 12.0125L12.0129 4.80005L19.2254 12.0125L18.3769 12.8611L12.0129 6.49711L5.64894 12.8611L4.80042 12.0125ZM7.8129 13.8126H6.6129L6.6129 18.0126L6.6129 19.2126H7.8129H16.2129L17.4129 19.2126V18.0126V13.8126H16.2129V18.0126H7.8129V13.8126Z"
    fill="#003E89"
  />
</svg>;
